module.exports = __webpack_public_path__ + "static/media/bgtop-company-5.381653f4.jpg";